import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from './components/scroll/scrollToTop';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId="282367153287-91vg39vpne0k4b52ovv2b9fmjf04rdhm.apps.googleusercontent.com">
    <React.StrictMode>
      <Router>
        < ScrollToTop />
        <App />
      </Router>
    </React.StrictMode >
  </GoogleOAuthProvider>
);

reportWebVitals();
